import { useDispatch } from 'react-redux';
import { logout } from '../../features/auth/clients/auth.client';
import * as authActions from '../../features/auth/actions/auth.actions';
import * as ecgActions from '../../features/ecg/actions/ecg.actions';

export const useLogout = () => {
  const dispatch = useDispatch();

  return async () => {
    const isLogout = await logout();
    if (isLogout) {
      dispatch(authActions.setUser({ user: null, meta: { history: false } }));
      dispatch(ecgActions.clean({ meta: { history: false } }));
    }
  };
};
